// File: components/HireCostSummary.js
import React from 'react';
import SummaryBox from './SummaryBox';

const HireCostSummary = ({
  salary,
  equity,
  successModifier,
  formatCurrency,
  isEA = false,
  eaType = null,
  tristenSavings = 0,
  title,
  description,
  location,
  applyLocationMultiplier,
  hoursPerWeek,
  workConfiguration,
  hireCostSummaryInfo,
  summaryBoxInfo
}) => {
  // Prepare summary items
  const getSummaryItems = () => {
    // Apply location multiplier if the function is provided
    const adjustedSalary = applyLocationMultiplier ? applyLocationMultiplier(salary) : salary;
    const adjustedSavings = applyLocationMultiplier ? applyLocationMultiplier(tristenSavings) : tristenSavings;

    const items = [];

    // Work configuration info
    if (workConfiguration) {
      items.push({
        label: hireCostSummaryInfo.workScheduleLabel,
        value: workConfiguration,
        type: "neutral",
        bold: false
      });
    } else if (hoursPerWeek !== undefined) {
      items.push({
        label: hireCostSummaryInfo.workScheduleLabel,
        value: hoursPerWeek === 40
          ? hireCostSummaryInfo.fullTimeText || "Full-time"
          : `${hireCostSummaryInfo.partTimeText || "Part-time"} (${hoursPerWeek} ${hireCostSummaryInfo.hrsWeekShortText || "hrs/wk"})`,
        type: "neutral",
        bold: false
      });
    }

    // Salary costs
    items.push({
      label: hireCostSummaryInfo.monthlyCostLabel,
      value: formatCurrency(Math.round(adjustedSalary / 12)),
      type: "cost",
      bold: true
    });

    items.push({
      label: hireCostSummaryInfo.annualCostLabel,
      value: `${formatCurrency(adjustedSalary)}`,
      type: "cost",
      bold: true
    });

    // Only show equity if it's not zero
    if (equity > 0) {
      items.push({
        label: hireCostSummaryInfo.equityLabel,
        value: `-${equity}%`,
        type: "equity",
        bold: true
      });
    }

    // Add EA-specific salary savings if applicable
    if (isEA && tristenSavings > 0) {
      items.push({
        label: hireCostSummaryInfo.tristenSavingsLabel,
        value: `-${formatCurrency(adjustedSavings)}`,
        type: "savings",
        bold: true
      });
    }

    // Add success modifier
    if (successModifier) {
      items.push({
        label: hireCostSummaryInfo.successModifierLabel,
        value: successModifier,
        type: "success",
        bold: true
      });
    } else if (isEA && eaType) {
      // For EA, we handle the success modifier differently
      items.push({
        label: hireCostSummaryInfo.successModifierLabel,
        value: isEA && eaType
          ? `+0.0-${eaType === 'regular' ? '2.0' : '7.0'}%`
          : successModifier,
        type: "success",
        bold: true
      });
    }

    return items;
  };

  return (
    <div className="mt-3">
      <SummaryBox items={getSummaryItems()} summaryBoxInfo={summaryBoxInfo} />
    </div>
  );
};

export default HireCostSummary;